var path = '/glow/component/glow-cart/tpl/cart-item.html';
var html = "<div class=glow-cart-control ng-style=$ctrl.styles.glowCartControl ng-click=$ctrl.cartOnClick()> <span ng-show=!$ctrl.item.inCart><span class=\"glyphicon glyphicon-plus\"></span> {{ $ctrl.strings['GLOW.CART.ADD'] }}</span> <span ng-show=$ctrl.item.inCart><span class=\"glyphicon glyphicon-minus\"></span> {{ $ctrl.strings['GLOW.CART.REMOVE'] }}</span> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/glow/component/glow-cart/tpl/cart-item.html
// module id = 1708
// module chunks = 1